/**
 * FormSelect component for rendering select fields with Formik.
 * This includes the label, the select itself and error message.
 *
 * ## Example usage:
 *
 *   ...
 */
import React from 'react'
import { ErrorMessage, Field } from 'formik'
import { Tooltip } from '../Tooltip'

type FormSelectProps = {
    name: string
    label: string
    options: { label: string; value: any }[]
    required?: boolean
    tooltip?: string
}

export function FormRadioInput({ label, name, tooltip, options, required = false, ...props }: FormSelectProps) {
    return (
        <div className="flex flex-col gap-1.5">
            <div className="flex justify-between gap-2">
                <div className="flex gap-1 items-center w-full">
                    <div className="text-base text-grey90">{label}</div>
                    {required ? <span className="text-red20">*</span> : null}
                    {tooltip ? <Tooltip>{tooltip}</Tooltip> : null}
                </div>

                <Field name={name}>
                    {({ field, form }: any) => (
                        <div className="flex gap-4 items-baseline mt-[2px]">
                            {options.map(option => (
                                <label key={option.value} className="flex items-center gap-1.5">
                                    <input type="radio" {...field} {...props} value={option.value} checked={field.value === option.value} />
                                    <span>{option.label}</span>
                                </label>
                            ))}
                        </div>
                    )}
                </Field>
            </div>

            <ErrorMessage name={name} component="span" className="text-sm text-red20" />
        </div>
    )
}
